// Several sections include this file; run it only once so the class is not declared twice
if (!window.__busoFrontpageCollectionLoaded) {
  window.__busoFrontpageCollectionLoaded = true;

class BusoFrontpageCollection {
  constructor(section) {
    this.section = section;
    this.wrapper = section.querySelector('.buso-collection__wrapper');
    this.expandButton = section.querySelector('[data-buso-collection-expand]');

    if (!this.wrapper) return;

    this.bindExpand();
    this.bindAnimate();
  }

  bindExpand() {
    if (!this.expandButton || this.expandButton.dataset.busoCollectionExpandInit === 'true') return;

    this.expandButton.dataset.busoCollectionExpandInit = 'true';
    this.expandButton.addEventListener('click', () => this.toggleExpanded());
  }

  toggleExpanded() {
    const isExpanded = this.section.classList.toggle('buso-collection--expanded');
    this.expandButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    this.expandButton.textContent = isExpanded ? 'Show less' : 'View All';

    const moreCards = this.section.querySelectorAll('.buso-collection-card--more');

    if (isExpanded) {
      this.wrapper.classList.add('buso-collection__animate');
      moreCards.forEach((card) => card.classList.add('buso-collection-card--revealed'));
      return;
    }

    moreCards.forEach((card) => card.classList.remove('buso-collection-card--revealed'));
  }

  bindAnimate() {
    if (this.wrapper.dataset.busoCollectionAnimateInit === 'true') return;

    this.wrapper.dataset.busoCollectionAnimateInit = 'true';

    if (getComputedStyle(this.wrapper).display === 'contents') {
      this.wrapper.classList.add('buso-collection__animate');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.wrapper.classList.add('buso-collection__animate');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    observer.observe(this.wrapper);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.buso-frontpage-collection').forEach((section) => {
    if (section.dataset.busoFrontpageCollectionInit === 'true') return;
    section.dataset.busoFrontpageCollectionInit = 'true';
    new BusoFrontpageCollection(section);
  });
});
}
